import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { pageTitleStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsPageTitle";

import { css } from "styled-components";

pageTitleStyles.brandStyles = mergeToNew(pageTitleStyles.brandStyles, {
    logoImage: {
        css: css`
            background: transparent;
            padding-left: 0;
            img {
                max-width: 150px;
                max-height: 150px;
            }
            [class^="TypographyStyle"] {
                font-size: 16px;
                padding-left: 0;
            }
        `,
    },
});
